import type { ScoreRow } from './scores-api';
import type { VisibleScore } from '../types';

export function hasReportScore(
  visibleScore: VisibleScore | undefined,
  report: { maxScore?: number } | undefined,
): boolean {
  if (visibleScore) {
    return !visibleScore.dentist.skipped
      && typeof visibleScore.dentist.value === 'number'
      && Number.isFinite(visibleScore.dentist.value);
  }
  return typeof report?.maxScore === 'number' && report.maxScore > 0;
}

export function toLearningScore(percentage: number, includesReport: boolean): { score: number; max: 50 | 100 } {
  const max = includesReport ? 100 : 50;
  return { score: Math.round((percentage / 100) * max), max };
}

export function getLearningScore(row?: ScoreRow | null): { score: number; max: 50 | 100 } | null {
  if (!row || typeof row.overall_score_value !== 'number' || !Number.isFinite(row.overall_score_value)) return null;
  const includesReport = typeof row.dentist_score_value === 'number' && Number.isFinite(row.dentist_score_value);
  return toLearningScore(row.overall_score_value, includesReport);
}

export function isCoursePassingScore(row: ScoreRow): boolean {
  const learningScore = getLearningScore(row);
  return typeof row.patient_score_value === 'number' && Number.isFinite(row.patient_score_value)
    && learningScore?.max === 100 && learningScore.score >= 80;
}
